import { Box, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useStore } from '../../../hooks';

import { observer } from 'mobx-react';
import { sanitizeHtml } from '@roc/ui/utils';

const useStyles = makeStyles(theme => ({
  alert: {
    '& + &': {
      marginTop: theme.spacing(2),
    },
  },
}));

export const PortalBannerMessages = observer(() => {
  const classes = useStyles();
  const { globalStore, userStore } = useStore();

  const allowLoanPricing = userStore.allowLoanPricing;
  const { routeBaseUrl } = globalStore;
  const messages = globalStore?.portalBannerMessages;

  return (
    <>
      {(messages?.length > 0 && allowLoanPricing) ? (
        <>
          <Box>
            {messages.map((message, index) => {
              const content: string = message.content.replace(':portal-base-url', routeBaseUrl);
              return (
                <Alert key={index} severity="warning" className={classes.alert}>
                  <AlertTitle>{message.title}</AlertTitle>
                  <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(content) }}></div>
                </Alert>
              );
            })}
          </Box>
          <br />
        </>) : <Grid />
      }
    </>
  );
});
